import React from "react";
import i18n from "i18n-react";

import { ContentHeader, Toolbox, BackButton } from "C4";

const ToolboxView = () => (
  <div className="contentContainer toolbox">
    <BackButton />
    <ContentHeader
      header={i18n.translate("nav.sell")}
      subtitle={i18n.translate("pageDescriptions.sell")}
      line
    />
    <Toolbox />
  </div>
);

export default ToolboxView;
